// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyAH1-j9SzExRSPa7g8R8ZpVGHT7tKz6TrA',
    authDomain: 'bemddops-wenb.firebaseapp.com',
    projectId: 'bemddops-wenb',
    storageBucket: 'bemddops-wenb.appspot.com',
    messagingSenderId: '986993124240',
    appId: '1:986993124240:web:517c6027e4e6536ff34915',
    measurementId: 'G-5JJY3RLB7F',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
